import React from 'react';

import { ActionItem } from '../ActionItem';
import { I18n } from 'common/i18n';

export const GoToSourceActionItem = ({
  isCatalogFederatedView,
  isDataFederatedView,
  sourceLink,
  link,
}: {
  isCatalogFederatedView: boolean;
  isDataFederatedView: boolean;
  sourceLink?: string;
  link: string;
}) => {
  // Only render for federated views
  if (!isCatalogFederatedView && !isDataFederatedView) {
    return null;
  }

  // For data federated views, use sourceLink; otherwise use link
  const assetLink = isDataFederatedView ? sourceLink! : link;

  const label = I18n.t('shared.asset_browser.result_list_table.action_dropdown.go_to_source');

  return <ActionItem label={label} href={assetLink} target="_blank" />;
};
